import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { getDialogByType } from '../accessors';
import { registerDialogs, unregisterDialogs, } from '../initializers/register-dialogs';
import { activeDialog } from '../selectors';
export const DialogsContainer = () => {
    const { type, dialogProps } = useSelector(activeDialog);
    useEffect(() => {
        registerDialogs();
        return () => {
            unregisterDialogs();
        };
    }, []);
    const DialogComponent = getDialogByType(type);
    return DialogComponent ? <DialogComponent {...dialogProps}/> : null;
};
